export class NullReferenceError extends Error {
	constructor(message: string) {
		super(message);

		Object.setPrototypeOf(this, NullReferenceError.prototype);
	}
}